import * as React from 'react'
import { useCallback } from 'react'
import Client from '../../../client'
import ListDialog from './ListDialog'
import DelistDialog from './DelistDialog'
import RelistDialog from './RelistDialog'
import SelectionManager from './SelectionManager'
import { DialogState } from './ListingManager'
import { channelById } from '../../../constants/Channels'

interface Props {
  selectionManager: SelectionManager
  dialogState: DialogState
  onClose: (stateKey: keyof DialogState) => void
  onSubmitted: () => void
  channelId?: number
}

export const BulkListingDialogs: React.FC<Props> = props => {
  const { onClose } = props
  const handleRelistClose = useCallback(() => {
    onClose('relistDialogOpen')
  }, [onClose])

  const channel = channelById(props.channelId)

  return (
    <>
      <ListDialog
        isOpen={props.dialogState.listDialogOpen}
        data={props.selectionManager.listable.map(listing => listing.id)}
        listEndpoint={channel.listEndpoint}
        marketName={channel.name}
        onClose={() => props.onClose('listDialogOpen')}
        onSubmitted={props.onSubmitted}
      />
      <DelistDialog
        title="Delist"
        isOpen={props.dialogState.delistDialogOpen}
        data={props.selectionManager.delistable.map(listing => listing.id)}
        endListingEndpoint={channel.delistEndpoint}
        onClose={() => props.onClose('delistDialogOpen')}
        onSubmitted={props.onSubmitted}
      />
      <RelistDialog
        data={props.selectionManager.relistable.map(listing => listing.id)}
        isOpen={props.dialogState.relistDialogOpen}
        onClose={handleRelistClose}
        onSubmitted={props.onSubmitted}
        onSubmit={({ price }) =>
          Client.bulkRelist(
            channel,
            props.selectionManager.relistable.map(listing => listing.id),
            { price }
          ).then(res => ({
            failed: res.data.failed
          }))
        }
      />
    </>
  )
}
